// components
import {
  PageSection,
  PageSectionInner,
  PageSectionTitle,
  PageSectionLead,
} from '@/components/PageSection';
import { GroupLabel } from '@/components/GroupLabel';

// datafiles
import { AWARDS, RECENT_AWARD_YEARS } from '@/datafiles/awards/list';

// styles
import { AwardsList, AwardsYear, EarlierRecognition } from './Awards.styles';

function AwardsYears({ groups }) {
  return (
    <AwardsList>
      {groups.map((group) => (
        <AwardsYear
          key={`awards-${group.year}`}
          aria-labelledby={`awards-year-${group.year}`}
        >
          <GroupLabel as="h3" id={`awards-year-${group.year}`}>
            {group.year}
          </GroupLabel>
          <ul>
            {group.awards.map((award) => (
              <li key={`awards-${group.year}-${award.name}`}>
                {award.link ? (
                  <a href={award.link}>{award.name}</a>
                ) : (
                  award.name
                )}
              </li>
            ))}
          </ul>
        </AwardsYear>
      ))}
    </AwardsList>
  );
}

export function Awards({ content }) {
  const recent = AWARDS.filter((group) =>
    RECENT_AWARD_YEARS.includes(group.year)
  );
  const earlier = AWARDS.filter(
    (group) => !RECENT_AWARD_YEARS.includes(group.year)
  );

  return (
    <PageSection>
      <PageSectionInner>
        <PageSectionTitle>{content.title}</PageSectionTitle>
        {content.lead && <PageSectionLead>{content.lead}</PageSectionLead>}
        <AwardsYears groups={recent} />
        {earlier.length > 0 && (
          <EarlierRecognition>
            <summary>{content.earlier_label}</summary>
            <AwardsYears groups={earlier} />
          </EarlierRecognition>
        )}
      </PageSectionInner>
    </PageSection>
  );
}
